/**
 * Rain and Water Droplets Effect for Geography lessons.
 */
import { ParticleSystem, Particle } from './ParticleSystem';
import { SVGObjectConfig } from '../objects/SVGObject';

export class RainEffect extends ParticleSystem {
  constructor(config: SVGObjectConfig) {
    super(config, 100);
    this.emitRate = 45;
  }

  protected createParticle(): Particle {
    return {
      x: (Math.random() - 0.5) * 800,
      y: -300,
      vx: -40,
      vy: 400 + Math.random() * 200,
      size: 2,
      alpha: 0.7,
      life: 0,
      maxLife: 1.5,
      color: '#38bdf8'
    };
  }

  protected updateParticle(p: Particle, delta: number): void {
    p.x += p.vx * delta;
    p.y += p.vy * delta;
  }
}
